<template>
  <div>
    <globalTitle />
  </div>
</template>

<script>
import globalTitle from '../globalTitle.vue'
export default {
  components: { globalTitle },
  name: 'outLink',
  mounted: {
    // 跳转外部
  }
}
</script>

<style lang="less" scoped></style>
